import React from 'react';
import {ReceiptEuro} from "lucide-react";
import SidebarUnitDesktop from "components/sidebar/components/SidebarUnitDesktop";

// The sidebar passes the icons of assets/icons their `wh` and `color`.
const InvoiceIcon = ({wh, color}) => <ReceiptEuro size={wh} color={color} strokeWidth={2} aria-hidden="true"/>;

const InvoiceLink = () => {
    return (
        <SidebarUnitDesktop
            routeName={"Factures"}
            routeSidebar={"/invoice/toBeSet"}
            icon={InvoiceIcon}
            text={"Factures"}
        />
    );
};

export default InvoiceLink;
